import "./style.css";
import layout from "./layout.html";
import Text from "@blocks/Text";
import CustomImage from "@blocks/Image";
import Credits from "@blocks/Credits";

export default class Block9 {
  static selector = ".block-9";

  constructor(block, attrs) {
    this.block = block;

    this.block.innerHTML = layout;

    this.introTitleNode = this.block.querySelector(".block-9__intro__title");
    this.introTextNode = this.block.querySelector(".block-9__intro .text");
    this.imageNode = this.block.querySelector(".image");
    this.imageTextNode = this.block.querySelector(".block-9__content .text");
    this.creditsNode = this.block.querySelector(".block-9__content .credits");

    this.attributes = attrs;
  }

  setupTitle = () => {
    this.introTitleNode.textContent = this.attributes.intro.title;
  };

  setup = async () => {
    return new Promise(async (resolve) => {
      this.setupTitle();
      await new Text(this.introTextNode, this.attributes.intro.text).onReady();

      await new Text(this.imageTextNode, this.attributes.text).onReady();

      await new Credits(this.creditsNode, this.attributes.credits).onReady();

      await new CustomImage(this.imageNode, this.attributes.image).onReady();

      resolve();
    });
  };

  onReady = async () => {
    return new Promise(async (resolve) => {
      this.mounted = true;
      await this.setup();
      resolve();
    });
  };
}
